import { FF_APP_INVOICE_NEW_DESIGN } from '@bundles/constant/featureFlags'
import { InvoiceHelpLauncher } from '@bundles/features/help-launcher'
import { InvoiceWhatsNewProvider } from '@bundles/features/whats-new'
import { overrideFeatureFlags } from '@fordeer/feature-flags'
import { RequireAuth } from '@bundles/layouts'
import AppNavigation from '@bundles/layouts/AppNavigation'
import { LoadingPage } from '@bundles/pages/loading-page'
import { AuthFailureModal } from '@bundles/routes/AuthFailureModal'
import { appRoutes, isNoFramePath } from '@bundles/routes/routeConfig'
import { trackMixpanel } from '@utils/mixpanelClient'
import { Suspense, useEffect, useRef } from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'

export const RouterWrapper = () => {
  const { pathname } = useLocation()
  const firstOpenRef = useRef(true)
  const isEnableFeatureFlag = window.location.href.includes(
    FF_APP_INVOICE_NEW_DESIGN,
  )
  const showAppNavigation = !isNoFramePath(pathname)

  useEffect(() => {
    overrideFeatureFlags({
      [FF_APP_INVOICE_NEW_DESIGN]: isEnableFeatureFlag,
    })
  }, [isEnableFeatureFlag])

  useEffect(() => {
    if (!firstOpenRef.current) {
      return
    }

    trackMixpanel('App open')
    firstOpenRef.current = false
  }, [])

  return (
    <RequireAuth>
      <InvoiceWhatsNewProvider>
        {showAppNavigation ? <AppNavigation /> : null}
        <Suspense fallback={<LoadingPage title="Loading..." />}>
          <Routes>
            {appRoutes.map(route => (
              <Route
                key={route.path}
                path={route.path}
                element={route.component}
              />
            ))}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Suspense>
        <AuthFailureModal />
        <InvoiceHelpLauncher />
      </InvoiceWhatsNewProvider>
    </RequireAuth>
  )
}
